(function () {
  'use strict';

  var instances = new Map();

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function tweenScrollTo(targetY, ms) {
    var startY = window.scrollY;
    var delta = targetY - startY;
    if (delta === 0) return;

    if (reducedMotion()) {
      window.scrollTo(0, targetY);
      return;
    }

    var startTime = Date.now();
    var timer = setInterval(function () {
      var k = Math.min(1, (Date.now() - startTime) / ms);
      var eased = 1 - Math.pow(1 - k, 3);
      window.scrollTo(0, startY + delta * eased);
      if (k >= 1) {
        clearInterval(timer);
        window.scrollTo(0, targetY);
      }
    }, 16);
  }

  function createInstance(root) {
    var progress = root.querySelector('[data-fym-progress]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-fym-tile]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-fym-panel]'));

    function setStep(step) {
      if (!progress) return;
      var stepEls = progress.querySelectorAll('[data-fym-step]');
      for (var i = 0; i < stepEls.length; i++) {
        var n = parseInt(stepEls[i].getAttribute('data-fym-step'), 10);
        stepEls[i].classList.toggle('is-active', n === step);
        stepEls[i].classList.toggle('is-done', n < step);
      }
    }

    function closeAll() {
      for (var i = 0; i < tiles.length; i++) {
        tiles[i].setAttribute('aria-expanded', 'false');
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].hidden = true;
      }
      setStep(1);
    }

    function findPanelByHandle(handle) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-category-handle') === handle) return panels[i];
      }
      var card = root.querySelector('[data-collection-handle="' + CSS.escape(handle) + '"]');
      if (card) return card.closest('[data-fym-panel]');
      return null;
    }

    function open(panel, options) {
      if (!panel) return;
      options = options || {};
      var tileId = panel.getAttribute('data-tile-target');
      var tile = tileId ? root.querySelector('#' + CSS.escape(tileId)) : null;

      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i] !== panel;
      }
      for (var j = 0; j < tiles.length; j++) {
        tiles[j].setAttribute('aria-expanded', tiles[j] === tile ? 'true' : 'false');
      }

      setStep(3);

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('style', panel.getAttribute('data-category-handle'));
        history.replaceState({}, '', url);
      }

      if (options.scroll !== false) {
        window.requestAnimationFrame(function () {
          var barHeight = progress ? progress.getBoundingClientRect().height : 0;
          var targetY = window.scrollY + panel.getBoundingClientRect().top - barHeight - 40;
          tweenScrollTo(Math.max(0, targetY), 420);
        });
      }
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        var panelId = tile.getAttribute('data-panel-target');
        var panel = panelId ? root.querySelector('#' + CSS.escape(panelId)) : null;
        open(panel);
      });
    });

    var resetButtons = root.querySelectorAll('[data-fym-reset]');
    resetButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeAll();
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.delete('style');
          history.replaceState({}, '', url);
        }
        var firstTile = tiles[0];
        if (firstTile) firstTile.focus();
      });
    });

    closeAll();

    var deepLinkHandle = new URL(window.location.href).searchParams.get('style');
    if (deepLinkHandle) {
      var panel = findPanelByHandle(deepLinkHandle);
      if (panel) open(panel, { scroll: false });
    }

    return {
      root: root,
      open: open,
      closeAll: closeAll,
      findPanelByHandle: findPanelByHandle
    };
  }

  function init(root) {
    if (instances.has(root)) return instances.get(root);
    var instance = createInstance(root);
    instances.set(root, instance);
    return instance;
  }

  function initAll() {
    document.querySelectorAll('[data-fym]').forEach(init);
  }

  function openBlockAncestorCategory(instance, blockId) {
    var target = null;
    var style = instance.root.querySelector('[data-block-id="' + CSS.escape(blockId) + '"]');
    if (style) {
      target = style.closest('[data-fym-panel]');
    } else {
      var tile = instance.root.querySelector('#' + CSS.escape('fym-tile-' + blockId));
      if (tile) {
        var panelId = tile.getAttribute('data-panel-target');
        target = panelId ? instance.root.querySelector('#' + CSS.escape(panelId)) : null;
      } else {
        target = instance.root.querySelector('#' + CSS.escape('fym-panel-' + blockId));
      }
    }
    if (target) instance.open(target, { scroll: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  function findRootIn(target) {
    if (!target || !target.querySelector) return null;
    if (target.matches && target.matches('[data-fym]')) return target;
    return target.querySelector('[data-fym]');
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = findRootIn(event.target);
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = findRootIn(event.target);
    if (root) instances.delete(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest('[data-fym]') : null;
    if (!root) return;
    var instance = init(root);
    var blockId = event.detail && event.detail.blockId;
    if (blockId) openBlockAncestorCategory(instance, blockId);
  });
})();
